import React from "react";
import { Checkbox, Input } from "antd";

import { Field, YesNo } from "./fields";

/**
 * Step 1 — who the plan is with. First on their paper form, and first here: it
 * is what the carrier rep asks for before answering anything else.
 */
export default function PlanStep({ value, onChange }) {
  function set(k, v) { onChange(Object.assign({}, value, { [k]: v })); }
  return (
    <div className="bw-card">
      <p className="bw-card-title">Plan &amp; carrier</p>
      <div className="bw-grid">
        <Field label="Employer / Plan">
          <Input value={value.employer || ""} onChange={function (e) { set("employer", e.target.value); }} />
        </Field>
        <Field label="Carrier">
          <Input value={value.carrier || ""} onChange={function (e) { set("carrier", e.target.value); }} />
        </Field>
        <Field label="Carrier phone">
          <Input value={value.carrierPhone || ""} onChange={function (e) { set("carrierPhone", e.target.value); }} />
        </Field>
        <Field label="Policy #">
          <Input value={value.policyNumber || ""} onChange={function (e) { set("policyNumber", e.target.value); }} />
        </Field>
        <Field label="Certificate #">
          <Input value={value.certificateNumber || ""} onChange={function (e) { set("certificateNumber", e.target.value); }} />
        </Field>
        <Field label="Account #" hint="The account the information was pulled under — it signs the shortform.">
          <Input value={value.accountNumber || ""} onChange={function (e) { set("accountNumber", e.target.value); }} />
        </Field>
        <Field label="Assignment">
          <YesNo value={value.assignment || ""} onChange={function (v) { set("assignment", v); }} />
        </Field>
        <Field label="EDI">
          <Checkbox checked={!!value.edi} onChange={function (e) { set("edi", e.target.checked); }}>
            Claims accepted electronically
          </Checkbox>
        </Field>
      </div>
    </div>
  );
}
